import { animate } from 'animejs';

class Nav {
	constructor() {
		let scrollPos;
		let cache = {};
		let initFunc = () => {
			initCache();
			registerEvents();
		};

		let initCache = () => {
			cache.nav = document.querySelector("header");
			cache.navBtn = cache.nav.querySelectorAll(".right .item.parent");
			cache.navmobile = cache.nav.querySelector(".nav-mobile");
			cache.navmobileBtn = cache.nav.querySelector(".burger");
			if (cache.navmobile && cache.navmobile.querySelector(".item.parent")) {
				cache.navMobileSubBtn = cache.navmobile.querySelectorAll(
					".item.parent"
				);
			}
		};

		let registerEvents = () => {
			window.addEventListener("scroll", scrollDetect);
			cache.navmobileBtn.addEventListener("click", openNav);
			for (let i = 0; i < cache.navBtn.length; i++) {
				cache.navBtn[i].addEventListener("click", toggleSubMenu);
			}
			if (cache.navmobile && cache.navmobile.querySelector(".item.parent")) {
				for (let i = 0; i < cache.navMobileSubBtn.length; i++) {
					cache.navMobileSubBtn[i].addEventListener(
						"click",
						toggleMobileAccordion
					);
				}
			}
		};

		let toggleSubMenu = function() {
			if (!cache.nav.classList.contains("open")) {
				cache.nav.classList.add("open");
				cache.nav.addEventListener("mouseleave", closeSubMenu);
				window.addEventListener("scroll", closeSubMenu);
			}
			if (this.classList.contains("nav_active")) {
				closeSubMenu();
			} else {
				if (cache.nav.querySelector(".sub.nav_active")) {
					const subnav_active = cache.nav.querySelector(".sub.nav_active");
					subnav_active.classList.remove("nav_active");
					cache.nav
						.querySelector(".right .item.parent.nav_active")
						.classList.remove("nav_active");
					anime({
						targets: subnav_active,
						opacity: [1, 0],
						translateY: [0, -100],
						duration: 400,
						easing: "easeOutQuad",
						complete: function() {
							subnav_active.style.display = "none";
						},
					});
				}

				const targetBtn = this;
				const sub = cache.nav.querySelector("." + targetBtn.dataset.sub);
				targetBtn.classList.add("nav_active");
				sub.style.display = "flex";
				sub.classList.add("nav_active");
				animate(sub, {
					opacity: [0, 1],
					translateY: [-100, 0],
					duration: 400,
					ease: "easeOutQuad",
				});
			}
		};

		let closeSubMenu = function() {
			const subnav_active = cache.nav.querySelector(".sub.nav_active");
			subnav_active.classList.remove("nav_active");
			cache.nav
				.querySelector(".right .item.parent.nav_active")
				.classList.remove("nav_active");
			cache.nav.classList.remove("open");
			cache.nav.removeEventListener("mouseleave", closeSubMenu);
			window.removeEventListener("scroll", closeSubMenu);
			animate(subnav_active, {
				opacity: [1, 0],
				translateY: [0, -100],
				duration: 400,
				ease: "easeOutQuad",
				complete: function() {
					subnav_active.style.display = "none";
				},
			});
		};

		// MOBILE

		let openNav = () => {
			cache.navmobileBtn.removeEventListener("click", openNav);
			cache.navmobileBtn.classList.add("open");
			cache.navmobile.style.display = "flex";
			document.querySelector("body").classList.add("overflow");
			document.querySelector("html").classList.add("overflow");

			animate(cache.navmobile, {
				opacity: [0, 1],
				translateY: [-450, 0],
				duration: 400,
				ease: "easeOutQuad",
				complete: function() {
					cache.navmobileBtn.addEventListener("click", closeNav);
				},
			});
		};

		let closeNav = () => {
			cache.navmobileBtn.removeEventListener("click", closeNav);
			document.querySelector("body").classList.remove("overflow");
			document.querySelector("html").classList.remove("overflow");
			cache.navmobileBtn.classList.remove("open");

			// Fermer tous les accordéons ouverts
			const openAccordionParents = document.querySelectorAll(
				".nav-mobile .item.parent.open"
			);
			if (openAccordionParents.length) {
				openAccordionParents.forEach((item) => {
					item.classList.remove("open");
				});

				const openAccordions = document.querySelectorAll(".accordion-content");
				if (openAccordions.length) {
					openAccordions.forEach((accordion) => {
						accordion.style.height = "0px";
					});
				}
			}

			if (cache.nav.querySelector(".sub.nav_active")) {
				const sub = cache.nav.querySelector(".sub.nav_active");
				animate(sub, {
					opacity: [1, 0],
					translateY: [0, -250],
					duration: 400,
					ease: "easeOutQuad",
					complete: function() {
						sub.classList.remove("nav_active");
						sub.style.display = "none";
					},
				});
			}
			animate(cache.navmobile, {
				opacity: [1, 0],
				translateY: [0, -250],
				duration: 400,
				ease: "easeOutQuad",
				complete: function() {
					cache.navmobileBtn.addEventListener("click", openNav);
					cache.navmobile.style.display = "none";
				},
			});
		};

		let toggleMobileAccordion = function(e) {
			e.preventDefault();
			e.stopPropagation();

			const parentElement = this;

			const accordionContent = parentElement.nextElementSibling;

			if (
				!accordionContent ||
				!accordionContent.classList.contains("accordion-content")
			) {
				console.error("Contenu d'accordéon non trouvé", parentElement);
				return;
			}

			parentElement.classList.toggle("open");

			if (parentElement.classList.contains("open")) {
				// Fermer tous les autres accordéons d'abord
				const allParents = cache.navmobile.querySelectorAll(
					".item.parent.open"
				);
				for (let i = 0; i < allParents.length; i++) {
					if (allParents[i] !== parentElement) {
						allParents[i].classList.remove("open");
						const otherAccordion = allParents[i].nextElementSibling;
						if (
							otherAccordion &&
							otherAccordion.classList.contains("accordion-content")
						) {
							otherAccordion.style.height = "0px";
						}
					}
				}

				accordionContent.style.height = "auto";
				const height = accordionContent.offsetHeight;
				accordionContent.style.height = "0px";

				void accordionContent.offsetHeight;

				animate(accordionContent, {
					height: height,
					duration: 400,
					ease: "easeOutQuad",
				});
			} else {
				animate(accordionContent, {
					height: 0,
					duration: 400,
					ease: "easeOutQuad",
				});
			}
		};

		let scrollDetect = function() {
			let up = false;
			if (scrollPos > window.pageYOffset) {
				up = true;
			}
			scrollPos = window.pageYOffset;

			if (
				!up &&
				scrollPos > 50 &&
				!cache.nav.classList.contains("up")
			) {
				document.querySelector("body").classList.add("up");
				cache.nav.classList.add("up");
				animate(cache.nav, {
					translateY: ["0%", "-100%"],
					duration: 500,
					ease: "easeOutQuad",
				});
			} else if (
				up &&
				cache.nav.classList.contains("up")
			) {
				document.querySelector("body").classList.remove("up");
				cache.nav.classList.remove("up");
				animate(cache.nav, {
					translateY: ["-100%", "0%"],
					duration: 500,
					ease: "easeOutQuad",
				});
			}
		};

		initFunc();
	}
}
export { Nav };
